import React from "react";

import type { NoteDetail } from "@/core/types";

import { AdvancedCareActivityView } from "../(advanced-care)/AdvancedCareActivityView";
import { CareCommunicationView } from "../(care-communication)/CareCommunicationView";
import { CareCoordinationView } from "../(care-coordination)/CareCoordinationView";
import { CareManagementForm } from "../(care-management)/CareManagementForm";
import { CaseManagementView } from "../(case-management)/CaseManagementView";
import { CheckInView } from "../(check-in)/CheckInView";
import { GuidedSessionView } from "../(guided-session)/GuidedSessionView";
import { SessionNoteView } from "../(session-note)/SessionNoteView";

type NoteContentProps = {
  isEditing?: boolean;
  note: NoteDetail;
  patientName?: string;
  profileName?: string | null;
  refetchNote?: () => void;
  setIsEditing?: (v: boolean) => void;
};

export function NoteContentRouter({
  isEditing = false,
  note,
  patientName,
  profileName = null,
  refetchNote = () => {},
  setIsEditing = () => {},
}: NoteContentProps) {
  switch (note?.note_type) {
    case "Care Management":
      return (
        <CareManagementForm
          isEditing={isEditing}
          isEmbedded
          nameToSign={note.provider_name ?? profileName}
          noteState={note}
          patientId={note.patient_id}
          refetchNote={refetchNote}
          setIsEditing={setIsEditing}
        />
      );

    case "Advanced Care Activity":
      return (
        <AdvancedCareActivityView
          isEditing={isEditing}
          isEmbedded
          nameToSign={note.provider_name ?? profileName}
          note={note}
          refetchNote={refetchNote}
          setIsEditing={setIsEditing}
        />
      );

    default:
      break;
  }

  switch (note.version ?? 1) {
    case 1:
      return <SessionNoteView note={note} patientName={patientName} />;

    case 2:
      return <GuidedSessionView note={note} views={{ profileView: true }} />;

    case 3:
      return <CheckInView note={note} />;

    case 4:
      return <CareCoordinationView note={note} />;

    case 5:
      return note?.note_type !== "Discharge" ? <CareCommunicationView note={note} /> : null;

    case 6:
      return <CaseManagementView note={note} />;

    default:
      return null;
  }
}
